import {
  BUSINESS_TYPE_CREATE, BUSINESS_TYPE_SAVE_FAILURE, BUSINESS_TYPE_SAVE_SUCCESS
} from './mutation-types'

export default {
  state: {
    business_types: []
  },
  getters: {
    business_types: state => {
      return state.business_types
    }
  },
  actions: {
    [BUSINESS_TYPE_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/business_types', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(BUSINESS_TYPE_SAVE_FAILURE, res.data)
            } else {
              commit(BUSINESS_TYPE_SAVE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [BUSINESS_TYPE_SAVE_FAILURE] (state, data) {
      console.log('USER_TYPE_SAVE_FAILURE')
    },
    [BUSINESS_TYPE_SAVE_SUCCESS] (state, data) {
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/businesstype-new.js